<template>
  <div class="content">
    <div class="left-sidebar" id="left-sidebar">
      <el-menu default-active="1-1" class="el-menu-vertical-demo">
        <el-submenu v-for="item in items" :index="item.index" :key="item.index">
          <template slot="title">
            <i class="el-icon-menu"></i>{{ item.name }}</template
          >
          <el-menu-item
            v-for="option in item.options"
            :index="option.index"
            :key="option.index"
          >
            <router-link :to="option.link">{{ option.name }}</router-link>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <keep-alive :max="1">
      <router-view
        v-if="$route.meta.keepAlive"
        class="right-iframe"
        id="right-iframe"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      class="right-iframe"
      id="right-iframe"
    ></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          name: "高校管理",
          index: "1",
          options: [
            {
              index: "1-1",
              link: "/xiaoyuan/college/manage",
              name: "高校管理",
            },
            {
              index: "1-2",
              link: "/xiaoyuan/GX/schoolManage",
              name: "校区管理",
            },
            {
              index: "1-3",
              link: "/xiaoyuan/GX/departmentManage",
              name: "院系管理",
            },
            {
              index: "1-4",
              link: "/xiaoyuan/GX/Manager",
              name: "管理员账号管理",
            },
            {
              index: "1-5",
              link: "/xiaoyuan/GX/teacherManage",
              name: "教师管理",
            },
            {
              index: "1-6",
              link: "/xiaoyuan/GX/pointManage",
              name: "点位管理",
            },
            {
              index: "1-7",
              link: "/xiaoyuan/GX/cheatManage",
              name: "作弊管理",
            },
            // { index: '1-8', link: '/xiaoyuan/GX/announcement/announcementManage', name: '公告管理' }
            {
              index: "1-8",
              link: "/xiaoyuan/announcement/manage",
              name: "公告管理",
            },
            { index: "1-9", link: "/xiaoyuan/menu/menu", name: "菜单管理" },
            {
              index: "1-10",
              link: "/xiaoyuan/sports/statistic",
              name: "运动会统计",
            },
          ],
        },
        {
          name: "设备管理",
          index: "2",
          options: [
            // { index: '2-1', link: '/xiaoyuan/maintenance/equipment/equipmentList', name: '设备列表' },
            {
              index: "2-1",
              link: "/xiaoyuan/equipment/list",
              name: "设备列表",
            },
            {
              index: "2-2",
              link: "/xiaoyuan/firmware/manage",
              name: "固件包管理",
            },
            {
              index: "2-3",
              link: "/xiaoyuan/master/device",
              name: "主控设备管理",
            },
          ],
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?4e62fefb